module.exports = __webpack_public_path__ + "static/how-card-orange-7266cc115c9b99380215ed319decafc0.svg";